package kz.dentalcrm.app.screens.quick_replies.edit.mvi

import kz.dentalcrm.app.core.base.ViewState

data class EditQuickReplyViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {

    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Editing : ScreenState
        data object Edited : ScreenState
        data object Deleted : ScreenState
        data class Error(val error: String) : ScreenState
    }
}
